import React from "react";
import { BrowserView, MobileView } from "react-device-detect";

import { FetchModalID } from "src/ipm-shared/components/GlobalUI/actions";

import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import ChangePassword from "src/bepaid/layouts/Menu/components/ChangePassword";
import MainLayout from "src/bepaid/layouts/MainLayout";

import styles from "./ChangePassword.module.scss";

const View = (props: any) => {
  const toggleModal = () => {
    props.toggleModal(FetchModalID.CHANGE_PASSWORD);
  };

  const onChanged = () => {
    props.toggleModal(FetchModalID.CHANGE_PASSWORD);
  };

  const renderContent = () => (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <ChangePassword onChanged={onChanged} />
      </div>
    </div>
  );

  return (
    <>
      <BrowserView>
        <DesktopModalLayout title={"Change password"} onClose={toggleModal}>
          {renderContent()}
        </DesktopModalLayout>
      </BrowserView>
      <MobileView>
        <MainLayout
          header={{
            title: "Change password",
            hideMenu: true,
            onClose: toggleModal
          }}
        >
          {renderContent()}
        </MainLayout>
      </MobileView>
    </>
  );
};

export default View;
